import { motion } from "framer-motion";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
// import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { GiBleedingEye } from "react-icons/gi";
import { HiOutlineCode } from "react-icons/hi";
import { WorkStyle } from "./Body.styled/Work.styled";
import { AnimateProjects } from "./Animate/Work.Animate";

function Work() {
  // const [active, setActive] = useState(false);

  return (
    <WorkStyle id="projects">
      <div className="workContainer">
        <div className="workHeader">Projects Built...</div>

        <Splide
          aria-label="projectsBuilt"
          hasTrack={false}
          options={{
            type: "loop",
            autoplay: true,
            // pauseOnHover: true,
            resetProgress: false,
            easing: "cubic-bezier(.44,.65,.07,1.01)",
            hasAutoplayProgress: true,
          }}
        >
          <div style={{ position: "relative" }}>
            <SplideTrack>
              <SplideSlide>
                <motion.div
                  className="projects project__Blog"
                  initial="initial"
                  whileInView="animate"
                  variants={AnimateProjects}
                >
                  <h1>Ideas Worth Billions</h1>
                  <div className="summary">
                    <span>
                      IWB is a technology startup i am currently working for
                      aimed at connecting young minds to Opportuinities.The site
                      is a responsive web page SPA.
                    </span>
                  </div>
                  <div className="techUsed">
                    React Js <span>+</span>Framer Motion <span>+</span> React
                    Splide
                  </div>
                  <div className="actionBtn">
                    <a
                      href="http://iwborg.netlify.app"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>
                        <div>
                          {" "}
                          Live <GiBleedingEye />
                        </div>
                      </button>
                    </a>
                    <a
                      href="https://github.com/Praizleye/IWB-Website-Build"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>
                        <div>
                          Code
                          <HiOutlineCode />
                        </div>
                      </button>
                    </a>
                  </div>
                </motion.div>
              </SplideSlide>

              <SplideSlide>
                <motion.div
                  className="projects project__stockDB"
                  initial="initial"
                  whileInView="animate"
                  variants={AnimateProjects}
                >
                  <h1>Budget Analyser</h1>
                  <div className="summary">
                    <span>
                      {" "}
                      A budget app that takes and records your daily expenditure
                      (both inflows and outflows) as supplied by the user.
                    </span>
                  </div>
                  <div className="techUsed">
                    REACT.JS <span>+ </span>JSON SERVER <span>+</span>CHART.JS
                  </div>
                  <div className="actionBtn">
                    <button disabled>
                      <div>
                        {" "}
                        Live <GiBleedingEye />
                      </div>
                    </button>
                    <a
                      href="https://github.com/Praizleye/Budget-Analyser-App"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>
                        <div>
                          Code
                          <HiOutlineCode />
                        </div>
                      </button>
                    </a>
                  </div>
                </motion.div>
              </SplideSlide>

              <SplideSlide>
                <motion.div
                  className="projects project__BudgetAnalyser"
                  initial="initial"
                  whileInView="animate"
                  variants={AnimateProjects}
                >
                  <h1>Twitter Clone</h1>
                  <div className="summary">
                    <span>
                      {" "}
                      Built a twitter clone for teaching purposes to beginner
                      programmers so as to understand css more powerfully.
                    </span>
                  </div>
                  <div className="techUsed">
                    VANILLA.JS <span>+ </span>SCSS <span>+</span> HTML
                  </div>
                  <div className="actionBtn">
                    <button disabled>
                      <div>
                        {" "}
                        Live <GiBleedingEye />
                      </div>
                    </button>
                    <a
                      href="https://github.com/Praizleye/twitter-clone-lessons-for-beginners"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>
                        <div>
                          Code
                          <HiOutlineCode />
                        </div>
                      </button>
                    </a>
                  </div>
                </motion.div>
              </SplideSlide>

              <SplideSlide>
                <motion.div
                  className="projects project__TwitterClone"
                  initial="initial"
                  whileInView="animate"
                  variants={AnimateProjects}
                >
                  <h1>Ladi Maji Foundation</h1>
                  <div className="summary">
                    <span>
                      {" "}
                      Ladi Maji foundation is a non-profit organisation that
                      caters for widows and less priveledged children.
                    </span>
                  </div>
                  <div className="techUsed">
                    VANILLA.JS <span>+ </span>GSAP <span>+</span> GOOGLE MAPS
                  </div>
                  <div className="actionBtn">
                    <button disabled={true}>
                      <div>
                        {" "}
                        Live <GiBleedingEye />
                      </div>
                    </button>
                    <a
                      href="https://github.com/Praizleye/Ladi-Maji-Project"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>
                        <div>
                          Code
                          <HiOutlineCode />
                        </div>
                      </button>
                    </a>
                  </div>
                </motion.div>
              </SplideSlide>
            </SplideTrack>
          </div>

          <div className="splide__progress">
            <div className="splide__progress__bar" />
          </div>
        </Splide>
      </div>
    </WorkStyle>
  );
}

export default Work;
